import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Landing from "./Pages/Landing";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import TransactionHistory from "./Pages/TransactionHistory";
import Levels from "./Pages/Levels";
import EditPersonal from "./Pages/EditPersonal";
import CheckIn from "./Pages/CheckIn";
import Starting from "./Pages/Starting";
import WalletTransactionHistory from "./Pages/WalletTransitionHistory";

function App() {


  useEffect(() => {
      const imageElement = document.createElement('div');
      imageElement.classList.add('landing-background');
      document.body.appendChild(imageElement);
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/home" element={<Home />} />
        <Route path="/transaction_history" element={<TransactionHistory />} />
         <Route path="/levels" element={<Levels />} />
        <Route path="/starting" element={<Starting />} />
        <Route path="/change_profile" element={<EditPersonal />} />
        <Route path="/check_in" element={<CheckIn />} />
          <Route path="/walletTransactionHistory" element={<WalletTransactionHistory />} />
        <Route path="*" element={<h1>Page Not Found</h1>} />
      </Routes>
    </div>
  );
}

export default App;
